import { createContext, useContext, useState, useCallback } from "react";

const HI = {
  // Nav
  "Dashboard": "डैशबोर्ड", "Log": "लॉग", "Entries": "एंट्रियाँ", "Progress": "प्रगति",
  "Profile": "प्रोफ़ाइल", "Players": "खिलाड़ी", "Console": "कंसोल", "Log out": "लॉग आउट",
  // Landing
  "Built for all budding cricket players": "हर उभरते क्रिकेटर के लिए बना",
  "Track every ball.": "हर गेंद ट्रैक करें।",
  "Own your game.": "अपने खेल के मालिक बनें।",
  "CrickTrack is the performance journal for grassroots and semi-pro cricketers. Log matches and nets, map your shots, and turn raw scores into sharp, coach-ready analytics.":
    "क्रिकट्रैक ज़मीनी और सेमी-प्रो क्रिकेटरों के लिए परफ़ॉर्मेंस जर्नल है। मैच और नेट्स लॉग करें, अपने शॉट मैप करें, और स्कोर को कोच-रेडी एनालिटिक्स में बदलें।",
  "Start tracking free": "मुफ़्त ट्रैकिंग शुरू करें",
  "I have an account": "मेरा खाता है",
  "Get Started": "शुरू करें", "Log in": "लॉग इन",
  "Everything a cricketer needs": "क्रिकेटर की हर ज़रूरत",
  "From scorebook to scouting report.": "स्कोरबुक से स्काउटिंग रिपोर्ट तक।",
  "90-Second Logging": "90-सेकंड लॉगिंग",
  "Batting, bowling & fielding with cricket-notation overs and live strike rate, economy, dot% as you type.": "टाइप करते ही बल्लेबाज़ी, गेंदबाज़ी और फ़ील्डिंग — क्रिकेट नोटेशन ओवर और लाइव स्ट्राइक रेट, इकॉनमी, डॉट% के साथ।",
  "Wagon Wheel": "वैगन व्हील",
  "Tap-to-map every shot across 8 sectors, mirrored by batting hand, with zone analytics and dismissal overlays.": "8 सेक्टरों में हर शॉट को टैप करके मैप करें, बल्लेबाज़ी हाथ के अनुसार, ज़ोन एनालिटिक्स और आउट ओवरले के साथ।",
  "Analytics Dashboard": "एनालिटिक्स डैशबोर्ड",
  "Form index, consistency score, trends, and practice-vs-tournament radar comparisons.": "फ़ॉर्म इंडेक्स, कंसिस्टेंसी स्कोर, ट्रेंड और प्रैक्टिस बनाम टूर्नामेंट रडार तुलना।",
  "Coach Portal": "कोच पोर्टल",
  "Link a coach, share progress, and collect timestamped notes on every innings.": "कोच को जोड़ें, प्रगति साझा करें और हर पारी पर समयबद्ध नोट्स पाएँ।",
  "Goals & Reports": "लक्ष्य और रिपोर्ट",
  "Season goals as progress bars with pace-to-target and auto report cards after every match.": "सीज़न लक्ष्य प्रोग्रेस बार के रूप में, टारगेट की गति और हर मैच के बाद ऑटो रिपोर्ट कार्ड।",
  "Private by Default": "डिफ़ॉल्ट रूप से निजी",
  "Your reflections and audio notes stay private. Share a public sports card only when you choose.": "आपकी समीक्षा और ऑडियो नोट्स निजी रहते हैं। सार्वजनिक स्पोर्ट्स कार्ड तभी साझा करें जब आप चाहें।",
  // Auth
  "Welcome back to": "वापसी पर स्वागत है", "the middle.": "मैदान में।",
  "Pick up where you left off — your season is waiting.": "जहाँ छोड़ा था वहीं से शुरू करें — आपका सीज़न इंतज़ार कर रहा है।",
  "Enter your details to continue.": "जारी रखने के लिए अपनी जानकारी दर्ज करें।",
  "Email": "ईमेल", "Password": "पासवर्ड", "New here?": "नए हैं?",
  "Create an account": "खाता बनाएँ", "Create your account": "अपना खाता बनाएँ",
  "Start tracking in under a minute.": "एक मिनट से भी कम में ट्रैकिंग शुरू करें।",
  "Full name": "पूरा नाम", "Phone (optional)": "फ़ोन (वैकल्पिक)",
  "Create account": "खाता बनाएँ", "Already have an account?": "पहले से खाता है?",
  "player": "खिलाड़ी", "coach": "कोच",
  "Log & analyze your game": "अपना खेल लॉग और विश्लेषण करें",
  "Coach linked players": "जुड़े खिलाड़ियों को कोच करें",
  // Logger
  "Log Performance": "प्रदर्शन लॉग करें", "Tournament": "टूर्नामेंट", "Practice": "प्रैक्टिस",
  "Batting": "बल्लेबाज़ी", "Bowling": "गेंदबाज़ी", "Fielding": "फ़ील्डिंग", "Reflections": "समीक्षा",
  "Save entry": "एंट्री सेव करें", "Save & log another": "सेव करें और दूसरी लॉग करें",
  "Update entry": "एंट्री अपडेट करें", "Clear draft": "ड्राफ़्ट हटाएँ",
  "Logging": "लॉगिंग", "Add": "जोड़ें", "Match notes": "मैच नोट्स", "private": "निजी",
  "Any match-specific update — conditions, plans, what worked…": "मैच से जुड़ी कोई भी बात — परिस्थिति, योजना, क्या काम आया…",
  "Date": "तारीख़", "Format": "फ़ॉर्मैट", "Practice type": "प्रैक्टिस प्रकार",
  "Opponent": "प्रतिद्वंद्वी", "Session focus": "सत्र का फ़ोकस", "Venue": "स्थान",
  "Playing for (team)": "किस टीम से खेल रहे हैं", "Select your team…": "अपनी टीम चुनें…",
  "Other (type below)": "अन्य (नीचे लिखें)", "Team name": "टीम का नाम",
  "Position": "बल्लेबाज़ी क्रम", "Runs": "रन", "Balls": "गेंदें", "Dots": "डॉट गेंदें",
  "Fours": "चौके", "Sixes": "छक्के", "Dismissal": "आउट होने का तरीका",
  "Maidens": "मेडन", "No-balls": "नो-बॉल", "Wides": "वाइड", "Balls override": "गेंद ओवरराइड",
  "Overs": "ओवर", "balls": "गेंदें", "Wickets": "विकेट",
  "Catches": "कैच", "Run-outs": "रन-आउट", "Stumpings": "स्टंपिंग", "Drops": "छूटे कैच",
  "Coach observations": "कोच की टिप्पणियाँ", "Self-assessment": "स्व-मूल्यांकन",
  "Key takeaways": "मुख्य सीख", "Self rating (1-10)": "स्व-रेटिंग (1-10)",
  "Strike Rate": "स्ट्राइक रेट", "Boundary %": "बाउंड्री %", "Economy": "इकॉनमी", "Dot %": "डॉट %",
  // dismissals
  "not out": "नाबाद", "bowled": "बोल्ड", "caught": "कैच आउट", "lbw": "एलबीडब्ल्यू",
  "run out": "रन आउट", "stumped": "स्टंप आउट", "hit wicket": "हिट विकेट", "caught & bowled": "कैच एंड बोल्ड",
  // practice types
  "nets": "नेट्स", "throwdowns": "थ्रोडाउन", "match-sim": "मैच-सिम", "fitness": "फ़िटनेस",
  // page titles
  "Settings": "सेटिंग्स", "My Clubs": "मेरे क्लब", "Privacy": "गोपनीयता", "Export data": "डेटा निर्यात",
  "My Entries": "मेरी एंट्रियाँ", "Season Goals": "सीज़न लक्ष्य", "Admin Console": "एडमिन कंसोल",
  "My Players": "मेरे खिलाड़ी", "Matches": "मैच", "Load demo": "डेमो लोड करें",
  "Edit profile": "प्रोफ़ाइल संपादित करें", "Save": "सेव करें",
  // entry detail / coach / progress
  "Report Card": "रिपोर्ट कार्ड", "Coach Notes": "कोच नोट्स", "Notes": "नोट्स",
  "Recent entries": "हाल की एंट्रियाँ", "Add a note": "नोट जोड़ें", "Post note": "नोट पोस्ट करें",
  "Invite a player": "खिलाड़ी को आमंत्रित करें", "Pending requests": "लंबित अनुरोध",
  "Zone analytics": "ज़ोन एनालिटिक्स", "Match": "मैच", "Player": "खिलाड़ी", "Edit": "संपादित करें",
  "Back to players": "खिलाड़ियों पर वापस", "Back": "वापस", "Out": "आउट", "Avg": "औसत", "Form": "फ़ॉर्म", "Wkts": "विकेट",
  "Recent Report Cards": "हाल के रिपोर्ट कार्ड", "Goal": "लक्ष्य", "Metric": "मापदंड", "Target": "टारगेट",
  "Add goal": "लक्ष्य जोड़ें", "No goals yet. Set one to track your season.": "अभी कोई लक्ष्य नहीं। अपने सीज़न को ट्रैक करने के लिए एक बनाएँ।",
  "Achieved!": "हासिल!", "Dictate": "बोलकर लिखें", "Stop": "रोकें", "Transcribing…": "लिखा जा रहा है…",
  "All types": "सभी प्रकार", "All formats": "सभी फ़ॉर्मैट", "All tournaments": "सभी टूर्नामेंट", "All teams": "सभी टीमें",
  "Clear demo": "डेमो हटाएँ", "Form & Consistency": "फ़ॉर्म और निरंतरता", "Form Index": "फ़ॉर्म इंडेक्स",
  "Consistency": "निरंतरता", "Best Batting": "सर्वश्रेष्ठ बल्लेबाज़ी", "Best Bowling": "सर्वश्रेष्ठ गेंदबाज़ी",
  "Batting Trend": "बल्लेबाज़ी ट्रेंड", "Bowling Trend": "गेंदबाज़ी ट्रेंड", "Practice vs Tournament": "प्रैक्टिस बनाम टूर्नामेंट",
  "No data yet": "अभी कोई डेटा नहीं",
  "Transcribed": "लिखा गया", "Transcription failed": "ट्रांसक्रिप्शन विफल",
  "Nothing heard — try again": "कुछ सुनाई नहीं दिया — फिर कोशिश करें", "Microphone access denied": "माइक्रोफ़ोन एक्सेस अस्वीकृत",
};

const MR = {
  // Nav
  "Dashboard": "डॅशबोर्ड", "Log": "नोंद", "Entries": "नोंदी", "Progress": "प्रगती",
  "Profile": "प्रोफाइल", "Players": "खेळाडू", "Console": "कन्सोल", "Log out": "बाहेर पडा",
  // Landing
  "Built for all budding cricket players": "सर्व उदयोन्मुख क्रिकेटपटूंसाठी",
  "Track every ball.": "प्रत्येक चेंडू ट्रॅक करा.",
  "Own your game.": "तुमच्या खेळावर प्रभुत्व मिळवा.",
  "CrickTrack is the performance journal for grassroots and semi-pro cricketers. Log matches and nets, map your shots, and turn raw scores into sharp, coach-ready analytics.":
    "क्रिकट्रॅक हे तळागाळातील आणि सेमी-प्रो क्रिकेटपटूंसाठी परफॉर्मन्स जर्नल आहे. सामने आणि नेट्स नोंदवा, तुमचे फटके मॅप करा आणि धावांचे रूपांतर धारदार, कोच-रेडी विश्लेषणात करा.",
  "Start tracking free": "मोफत ट्रॅकिंग सुरू करा",
  "I have an account": "माझे खाते आहे",
  "Get Started": "सुरू करा", "Log in": "लॉग इन",
  "Everything a cricketer needs": "क्रिकेटपटूला लागणारे सर्व काही",
  "From scorebook to scouting report.": "स्कोअरबुक ते स्काउटिंग रिपोर्टपर्यंत.",
  "90-Second Logging": "90-सेकंद नोंदणी",
  "Batting, bowling & fielding with cricket-notation overs and live strike rate, economy, dot% as you type.": "टाइप करताच फलंदाजी, गोलंदाजी आणि क्षेत्ररक्षण — क्रिकेट नोटेशन षटके आणि थेट स्ट्राइक रेट, इकॉनॉमी, डॉट% सह.",
  "Wagon Wheel": "वॅगन व्हील",
  "Tap-to-map every shot across 8 sectors, mirrored by batting hand, with zone analytics and dismissal overlays.": "8 विभागांत प्रत्येक फटका टॅप करून मॅप करा, फलंदाजीच्या हाताप्रमाणे, झोन विश्लेषण आणि बादच्या ओव्हरलेसह.",
  "Analytics Dashboard": "विश्लेषण डॅशबोर्ड",
  "Form index, consistency score, trends, and practice-vs-tournament radar comparisons.": "फॉर्म इंडेक्स, सातत्य गुण, कल आणि सराव विरुद्ध स्पर्धा रडार तुलना.",
  "Coach Portal": "प्रशिक्षक पोर्टल",
  "Link a coach, share progress, and collect timestamped notes on every innings.": "प्रशिक्षक जोडा, प्रगती शेअर करा आणि प्रत्येक डावावर वेळेसह नोंदी मिळवा.",
  "Goals & Reports": "ध्येये आणि अहवाल",
  "Season goals as progress bars with pace-to-target and auto report cards after every match.": "हंगामाची ध्येये प्रगती बार म्हणून, लक्ष्य गती आणि प्रत्येक सामन्यानंतर ऑटो रिपोर्ट कार्ड.",
  "Private by Default": "मूलतः खाजगी",
  "Your reflections and audio notes stay private. Share a public sports card only when you choose.": "तुमचा आढावा आणि ऑडिओ नोंदी खाजगी राहतात. सार्वजनिक स्पोर्ट्स कार्ड फक्त तुम्ही ठरवाल तेव्हाच शेअर करा.",
  // Auth
  "Welcome back to": "पुन्हा स्वागत आहे", "the middle.": "मैदानात.",
  "Pick up where you left off — your season is waiting.": "जिथे थांबलात तिथून सुरू करा — तुमचा हंगाम वाट पाहत आहे.",
  "Enter your details to continue.": "सुरू ठेवण्यासाठी तुमची माहिती भरा.",
  "Email": "ईमेल", "Password": "पासवर्ड", "New here?": "नवीन आहात?",
  "Create an account": "खाते तयार करा", "Create your account": "तुमचे खाते तयार करा",
  "Start tracking in under a minute.": "एका मिनिटात ट्रॅकिंग सुरू करा.",
  "Full name": "पूर्ण नाव", "Phone (optional)": "फोन (ऐच्छिक)",
  "Create account": "खाते तयार करा", "Already have an account?": "आधीच खाते आहे?",
  "player": "खेळाडू", "coach": "प्रशिक्षक",
  "Log & analyze your game": "तुमचा खेळ नोंदवा आणि विश्लेषण करा",
  "Coach linked players": "जोडलेल्या खेळाडूंना प्रशिक्षण द्या",
  // Logger
  "Log Performance": "कामगिरी नोंदवा", "Tournament": "स्पर्धा", "Practice": "सराव",
  "Batting": "फलंदाजी", "Bowling": "गोलंदाजी", "Fielding": "क्षेत्ररक्षण", "Reflections": "आढावा",
  "Save entry": "नोंद जतन करा", "Save & log another": "जतन करा आणि दुसरी नोंदवा",
  "Update entry": "नोंद अपडेट करा", "Clear draft": "ड्राफ्ट हटवा",
  "Logging": "नोंदणी सुरू", "Add": "जोडा", "Match notes": "सामन्याच्या नोंदी", "private": "खाजगी",
  "Any match-specific update — conditions, plans, what worked…": "सामन्याशी संबंधित काहीही — परिस्थिती, योजना, काय उपयोगी पडले…",
  "Date": "तारीख", "Format": "फॉरमॅट", "Practice type": "सरावाचा प्रकार",
  "Opponent": "प्रतिस्पर्धी", "Session focus": "सत्राचा फोकस", "Venue": "ठिकाण",
  "Playing for (team)": "कोणत्या संघाकडून खेळता", "Select your team…": "तुमचा संघ निवडा…",
  "Other (type below)": "इतर (खाली लिहा)", "Team name": "संघाचे नाव",
  "Position": "फलंदाजी क्रम", "Runs": "धावा", "Balls": "चेंडू", "Dots": "डॉट चेंडू",
  "Fours": "चौकार", "Sixes": "षटकार", "Dismissal": "बाद होण्याची पद्धत",
  "Maidens": "निर्धाव षटके", "No-balls": "नो-बॉल", "Wides": "वाइड", "Balls override": "चेंडू ओव्हरराइड",
  "Overs": "षटके", "balls": "चेंडू", "Wickets": "विकेट",
  "Catches": "झेल", "Run-outs": "रन-आउट", "Stumpings": "यष्टिचीत", "Drops": "सुटलेले झेल",
  "Coach observations": "प्रशिक्षकाची निरीक्षणे", "Self-assessment": "स्व-मूल्यांकन",
  "Key takeaways": "महत्त्वाचे मुद्दे", "Self rating (1-10)": "स्व-रेटिंग (1-10)",
  "Strike Rate": "स्ट्राइक रेट", "Boundary %": "सीमारेषा %", "Economy": "इकॉनॉमी", "Dot %": "डॉट %",
  // dismissals
  "not out": "नाबाद", "bowled": "त्रिफळाचीत", "caught": "झेलबाद", "lbw": "पायचीत",
  "run out": "धावचीत", "stumped": "यष्टिचीत", "hit wicket": "स्वहस्ते बाद", "caught & bowled": "झेल व गोलंदाजी",
  // practice types
  "nets": "नेट्स", "throwdowns": "थ्रोडाउन", "match-sim": "सामना-सिम", "fitness": "फिटनेस",
  // page titles
  "Settings": "सेटिंग्ज", "My Clubs": "माझे क्लब", "Privacy": "गोपनीयता", "Export data": "डेटा निर्यात",
  "My Entries": "माझ्या नोंदी", "Season Goals": "हंगामाची ध्येये", "Admin Console": "अ‍ॅडमिन कन्सोल",
  "My Players": "माझे खेळाडू", "Matches": "सामने", "Load demo": "डेमो लोड करा",
  "Edit profile": "प्रोफाइल संपादित करा", "Save": "जतन करा",
  // entry detail / coach / progress
  "Report Card": "रिपोर्ट कार्ड", "Coach Notes": "प्रशिक्षक नोंदी", "Notes": "नोंदी",
  "Recent entries": "अलीकडील नोंदी", "Add a note": "नोंद जोडा", "Post note": "नोंद पोस्ट करा",
  "Invite a player": "खेळाडूला आमंत्रित करा", "Pending requests": "प्रलंबित विनंत्या",
  "Zone analytics": "झोन विश्लेषण", "Match": "सामना", "Player": "खेळाडू", "Edit": "संपादित करा",
  "Back to players": "खेळाडूंकडे परत", "Back": "मागे", "Out": "बाद", "Avg": "सरासरी", "Form": "फॉर्म", "Wkts": "विकेट",
  "Recent Report Cards": "अलीकडील रिपोर्ट कार्ड", "Goal": "ध्येय", "Metric": "मापदंड", "Target": "लक्ष्यांक",
  "Add goal": "ध्येय जोडा", "No goals yet. Set one to track your season.": "अजून ध्येय नाही. हंगाम ट्रॅक करण्यासाठी एक ठरवा.",
  "Achieved!": "साध्य!", "Dictate": "बोलून लिहा", "Stop": "थांबा", "Transcribing…": "लिहित आहे…",
  "All types": "सर्व प्रकार", "All formats": "सर्व फॉरमॅट", "All tournaments": "सर्व स्पर्धा", "All teams": "सर्व संघ",
  "Clear demo": "डेमो हटवा", "Form & Consistency": "फॉर्म आणि सातत्य", "Form Index": "फॉर्म इंडेक्स",
  "Consistency": "सातत्य", "Best Batting": "सर्वोत्तम फलंदाजी", "Best Bowling": "सर्वोत्तम गोलंदाजी",
  "Batting Trend": "फलंदाजी कल", "Bowling Trend": "गोलंदाजी कल", "Practice vs Tournament": "सराव विरुद्ध स्पर्धा",
  "No data yet": "अजून डेटा नाही",
  "Transcribed": "लिहिले", "Transcription failed": "ट्रान्सक्रिप्शन अयशस्वी",
  "Nothing heard — try again": "काही ऐकू आले नाही — पुन्हा प्रयत्न करा", "Microphone access denied": "मायक्रोफोन प्रवेश नाकारला",
};

const DICTS = { en: {}, hi: HI, mr: MR };
export const LANGS = [["en", "EN"], ["hi", "हिं"], ["mr", "मरा"]];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ct_lang") || "en");
  const setLang = useCallback((l) => { localStorage.setItem("ct_lang", l); setLangState(l); }, []);
  const t = useCallback((s) => (DICTS[lang] && DICTS[lang][s]) || s, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
export const useT = () => useContext(I18nContext).t;
